import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import i18next from 'i18next';
import Row from 'react-bootstrap/Row';

import Background from '../../resources/assets/hero-home-oct-2020.jpeg';
import InputBox from '../../lib/InputBox';
import Overlay from '../../lib/Overlay';

export default function ResetRequestView(props) {
  const EMAIL_MAX_LENGTH = 100;   // maximum length in database
  const emailRegex = new RegExp(/(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-z0-9-]*[A-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/);
  const [email, setEmail] = useState('');

  return (<>
    <Container style={{
      minHeight: '450px',
      backgroundImage: `url(${Background})`,
      borderRadius: '3px' ,
      boxShadow: "0 0 8px 8px rgba(40, 44, 52, 0.7) inset"
      }}>
      <Row className="justify-content-md-center">
        <InputBox style={{ height: '350px', width: '760px' }}>
        { renderContents() }
        </InputBox>
      </Row>
    </Container>
  </>);

  function renderContents() {
    const action = {
      initial: renderForm(),
      waiting: renderForm(),
      sent: renderMessage()
    };

    return action[props.state];
  }

  function renderForm() {
    return (<>
      {props.state == 'waiting' && <Overlay />}
      <p>{i18next.t('reset.emailMessage')}</p>
      <Form style={{ width: '100%', margin: '1em' }} onSubmit={event => {event.preventDefault(); props.onSubmit(email)}}>
        <Form.Group controlId="login">
          <Form.Label>{i18next.t('reset.email')}</Form.Label>
          <Form.Control name="email" type="input" placeholder={i18next.t('reset.email')} value={email} maxLength={EMAIL_MAX_LENGTH} onChange={event => setEmail(event.target.value)} autoFocus />
        </Form.Group>
        <Button name="submit-request" variant="primary" type="button" disabled={isDisabled()} onClick={() => props.onSubmit(email)}>
          {i18next.t('reset.submitRequest')}
        </Button>
        {!isDisabled() && <input type='submit' hidden tabIndex='-1' />}
        <p id="message">{props.message}</p>
      </Form>
    </>);
  }

  function renderMessage() {
    return (<>
        <p id="message" style={{ margin: '1em' }}>{props.message}</p>
    </>);
  }

  function isDisabled() {
    return !(emailRegex.test(email));
  }
}
